'use strict';

import React from 'react';
import { withFormsy } from 'formsy-react';
import classNames from 'classnames';

import utils from 'services/utils';

import constants from 'constants/appConstants';
import DisplayField from 'components/base/form-components/DisplayField';
import modalActions from 'actions/ModalActionCreators';
import Spinner from 'components/base/Spinner';

import _ from 'underscore';

const propTypes = {
    
};

const defaultProps = {
    options: {},
    sortByValue: false,
    sortDescending: false,
};

class Select extends React.Component {

    constructor(props) {
        super(props);
        this._populateOptionsMap = this._populateOptionsMap.bind(this);
        this.handleUpKeyPress = this.handleUpKeyPress.bind(this);
        this.handleDownKeyPress = this.handleDownKeyPress.bind(this);
        this.handleSelectCallback = this.handleSelectCallback.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.handleSingleOptionSelectCallback = this.handleSingleOptionSelectCallback.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.state = {
            displayOptions: false,
            currentSelection: null,
            optionsMap: [],
            optionsIndexMap: {},
            selectedItemIndex: -1,
        };
    }

    componentDidMount() {
        if (_.size(this.props.options) > 0) {
            const optionsMap = this._populateOptionsMap(this.props);

            if (optionsMap.length === 1) {
                this.handleSingleOptionSelectCallback(optionsMap);
            } else if (this.props.getValue()) {
                this.handleSelectCallback(this.props.getValue(), this.props.options[this.props.getValue()]);
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.hideMenu);
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.options) > 0 && !(_.isEqual(nextProps.options, this.props.options))) {
            const optionsMap = this._populateOptionsMap(nextProps);
            if (optionsMap.length === 1) {
                this.handleSingleOptionSelectCallback(optionsMap);
            }
        }
    }

    _populateOptionsMap(props) {
        var optionsMap = [];
        var optionsIndexMap = {};

        _.each(props.options, function (label, value) {
            optionsMap.push({
                label,
                value,
            });
        });

        if (props.sortByValue) {
            optionsMap = utils.sort(optionsMap, i => i.label, props.sortDescending ? constants.sortOrders.DESCENDING : null);
        }

        if (props.optionsDisplayOrder) {
            const sortedOptionsMap = [];
            _.each(props.optionsDisplayOrder, (od) => {
                sortedOptionsMap.push(_.find(optionsMap, (option) => {
                    return option.value === String(od);
                }));
            });

            optionsMap = sortedOptionsMap;
        }

        var i = 0;
        _.each(optionsMap, function (o) {
            optionsIndexMap[o.value] = i;
            i++;
        });


        this.setState({
            optionsMap,
            optionsIndexMap,
            selectedItemIndex: props.value ? optionsIndexMap[props.value] : -1,
        });

        return optionsMap;
    }

    handleUpKeyPress() {
        this.setState({
            selectedItemIndex: this.state.selectedItemIndex > 0 ? this.state.selectedItemIndex - 1 : 0,
        }, () => {
            const containerEl = this.refs.list;
            const selectedlistElement = containerEl.querySelectorAll('.list-item')[this.state.selectedItemIndex];
            if (selectedlistElement.offsetTop < containerEl.scrollTop) {
                containerEl.scrollTop -= selectedlistElement.offsetHeight;
            }
        });
    }

    handleDownKeyPress() {
        this.setState({
            selectedItemIndex: this.state.selectedItemIndex < this.state.optionsMap.length - 1 ? this.state.selectedItemIndex + 1 : this.state.selectedItemIndex,
        }, () => {
            const containerEl = this.refs.list;
            const selectedlistElement = containerEl.querySelectorAll('.list-item')[this.state.selectedItemIndex];
            if (selectedlistElement.offsetTop > (containerEl.scrollTop + containerEl.offsetHeight) - selectedlistElement.offsetHeight) {
                containerEl.scrollTop += selectedlistElement.offsetHeight;
            }
        });
    }

    handleSelectCallback(value, label) {
        this.setState({
            currentSelection: value,
        });

        this.props.setValue(value);

        this.refs.select.focus();
        if (this.props.onChangeCallback) {
            if (typeof (this.props.onChangeCallback) === "function") {
                this.props.onChangeCallback(this.refs.select, value, label);
            } else if (typeof (this.props.onChangeCallback) === "object") {
                _.each(this.props.onChangeCallback, function (fn, i) {
                    fn(this.refs.select, value, label);
                });
            }
        }
    }

    handleOptionClick(value, index, event) {
        this.setState({
            selectedItemIndex: this.state.optionsIndexMap[value],
        });

        this.handleSelectCallback(value, index);
    }

    handleSingleOptionSelectCallback(optionsMap) {
        const singleOption = optionsMap[0];

        this.props.setValue(singleOption.value);

        if (this.props.onChangeCallback) {
            if (typeof (this.props.onChangeCallback) === "function") {
                setTimeout(function () {
                    this.props.onChangeCallback(this.refs.displayOnlySelect, singleOption.value, singleOption.label);
                }.bind(this), 0);                    
            } else if (typeof (this.props.onChangeCallback) === "object") {
                _.each(this.props.onChangeCallback, function (fn, i) {
                    setTimeout(function () {
                        fn(this.refs.displayOnlySelect, singleOption.value, singleOption.label);
                    }.bind(this), 0);                    
                });
            }
        }
    }

    handleKeyDown(event) {
        event.stopPropagation();

        switch (event.keyCode) {
        case 38: //up
            this.handleUpKeyPress();
            break;
        case 40: // down
            this.handleDownKeyPress();
            break;
        case 13: // Enter
            utils.preventDefault(event);
            var option = this.state.optionsMap[this.state.selectedItemIndex];
            this.handleSelectCallback(option.value, option.key);
            this.hideMenu();
            break;
        case 27: // Escape
            this.hideMenu();
            break;
        default:
            utils.preventDefault(event);
        }
    }

    hideMenu() {
        modalActions.enableEscapeButton();
        this.setState({
            displayOptions: false,
        });
        document.removeEventListener("click", this.hideMenu);
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    showMenu() {
        if (!this.props.disabled) {
            modalActions.disableEscapeButton();
            this.setState({
                displayOptions: true,
            });
            document.addEventListener("click", this.hideMenu);
            document.addEventListener("keydown", this.handleKeyDown);
        }
    }

    render() {

        const isSingleItem = this.props.isRequired() && this.state.optionsMap.length === 1;
        if (isSingleItem) {
            return (
                <DisplayField 
                    label={this.props.label}
                    name={this.props.name}
                    value={this.state.optionsMap[0].label}
                    disabled={this.props.disabled}
                    ref="displayOnlySelect"
                />
            );
        } else {
            var SelectItems = [];
            var theValue;
    
            var classes = classNames(
                'fc-select', this.props.className, {
                    'required': this.props.showRequired() && !this.props.isPristine(),
                    'error': !(this.props.showRequired() && !this.props.isPristine()) && this.props.showError(),
                    'server-error': this.props.serverMessage,
                    'disabled': this.props.disabled,
                    'loading': this.props.loading,
                    'no-label': this.props.noLabel,
                }
            );
    
            var listStyle = {
                display: this.state.displayOptions ? 'block' : 'none',
            };
    
            var requiredElement;
            if (this.props.isRequired()) {
                requiredElement = <span className="required-msg validation-error">{constants.error.FORMS.FORM_FIELD_REQUIRED}</span>;
            }
    
            _.each(this.state.optionsMap, function (el, index) {
                var selectClasses = classNames(
                    'list-item', {
                        highlighted: this.state.selectedItemIndex === this.state.optionsIndexMap[el.value],
                    }
                );
    
                SelectItems.push(<div className={selectClasses} key={el.value} onClick={this.handleOptionClick.bind(this, el.value, el.label)}>{el.label}</div>);
            }.bind(this));
    
    
            var initialValue = this.props.hintText || constants.message.SELECT_DEFAULT;
            if (this.props.getValue() || this.props.getValue() === 0) {
                initialValue = this.props.options[this.props.getValue()];
            } 

            return (
                <div id={'form-element-{0}'.format(this.props.name)} className={classes}>
                    <label htmlFor={this.props.name}>{this.props.label}</label>
                    <div id={this.props.name} className="select" ref="select" tabIndex="0" onClick={this.showMenu}>
                        {initialValue}
                        <Spinner
                            id={'spinner-' + this.props.name}
                            className="select-spinner"
                            display={this.props.loading}
                        />
                    </div>
    
                    <div id={"{0}-select-list".format(this.props.name)} className="select-list" ref="list" style={listStyle} disabled={this.props.isFormDisabled() || this.props.disabled}>
                        {SelectItems}
                    </div>
    
                    <span className="validation-error">{this.props.getErrorMessage()}</span>
                    <span className="server-error-msg validation-error">{this.props.serverMessage}</span>
                    {requiredElement}
                </div>
            );
        }
    }
}

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
export default withFormsy(Select); 
